import packageInfo from '../../package.json'
export const app = packageInfo.version

export default {
  app,
}
